














































































































































import {
  Component, Vue,
} from 'vue-property-decorator';
import EditEmergencyFundYourBudgetViewModel
  from '@/vue-app/view-models/components/goals-dashboard/edit-plan-goals/edit-emergency-fund-goal-plan/edit-emergency-fund-your-budget-view-model';

@Component({
  name: 'EditEmergencyFundYourBudget',
  components: {
    CustomTooltip: () => import('@/vue-app/components/custom/CustomTooltip.vue'),
  },
})
export default class EditEmergencyFundYourBudget extends Vue {
  edit_emergency_fund_view_model = Vue.observable(
    new EditEmergencyFundYourBudgetViewModel(this),
  );

  async mounted() {
    await this.edit_emergency_fund_view_model.initialize();
  }
}
